import { Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  apiUrl = '';
  constructor(private router: Router, private authService: AuthService, private ngZone: NgZone) { }

  getApiUrl() {
    if (this.apiUrl) {
      return this.apiUrl;
    }
    this.apiUrl = environment.apiUrl;
    return this.apiUrl;
  }

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    if (token) {
      return req.clone({ setHeaders: { 'Cache-Control': 'no-cache, no-store, must-revalidate', Authorization: token } });
    } else {
      return req.clone({ setHeaders: { 'Cache-Control': 'no-cache, no-store, must-revalidate' } });
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('assets/')) {
      return next.handle(req);
    }

    const apiUrl = this.getApiUrl();
    let reqUrl = req.url;

    if (!/^https?:\/\//i.test(req.url)) {
      reqUrl = apiUrl + req.url;
    }

    const accessToken = localStorage.getItem('access_token');
    let clonedReq = req.clone({
      url: reqUrl,
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        ...(accessToken ? { 'Authorization': `Bearer ${accessToken}` } : {}),
      },
    });

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (!this.router.url.startsWith('/auth')) {
            this.authService.logout();
          }
        }
        return throwError(() => error);
      })
    );
  }

}
